// extracted by mini-css-extract-plugin
module.exports = {"fixedBar":"NoSidebar_fixedBar__caaq6","productName":"NoSidebar_productName__uukNF","productPrice":"NoSidebar_productPrice__2EaTI","nominal":"NoSidebar_nominal__3zQrw"};